import { useEffect } from "react";

// Cierra un menú o panel desplegable al hacer clic fuera de `ref` o al
// presionar Escape. Solo escucha mientras está abierto.
const useCerrarAlClicFuera = (ref, abierto, cerrar) => {
  useEffect(() => {
    if (!abierto) return undefined;
    const alClicFuera = (evento) => {
      if (!ref.current?.contains(evento.target)) cerrar();
    };
    const alTeclear = (evento) => evento.key === "Escape" && cerrar();
    document.addEventListener("mousedown", alClicFuera);
    document.addEventListener("keydown", alTeclear);
    return () => {
      document.removeEventListener("mousedown", alClicFuera);
      document.removeEventListener("keydown", alTeclear);
    };
  }, [ref, abierto, cerrar]);
};

export default useCerrarAlClicFuera;
